import React from 'react';
import Radium from 'radium';

import AppUtil from 'AppUtil';
import AppConstants from 'AppConstants';

const BRIGHT_COLOR = '#f49600';
const DARK_COLOR = 'gray';

class PriceLabel extends React.Component {

	render() {
		const price = this.props.price;
		const productType = AppConstants.PRODUCT_TYPES[this.props.productType];

		const aliasPrice = this.props.aliasPrice || productType.basePrice;
		const discount = parseInt(AppUtil.calculatePercentDiff(price, aliasPrice), 10);

		const priceColor = this.props.invertColor === true? DARK_COLOR: BRIGHT_COLOR;
		const discountColor = this.props.invertColor === true? BRIGHT_COLOR: DARK_COLOR;

		const style = [{color: priceColor}];
			
		if(this.props.style) 
			style.push(this.props.style);

		const discountFont = this.props.discountFont? this.props.discountFont: '80%';

		return <span style={style}>
					<span>Rs. {AppUtil.formatNumber(price)}</span>

					{
						discount < 0 && 
						<span style={{display: 'block', fontSize: discountFont, color: discountColor}}>
							<span style={{textDecoration: 'line-through', marginRight: '5px'}}>Rs. {AppUtil.formatNumber(aliasPrice)}</span>	

							<span>{Math.abs(discount)}% off</span>	
						</span>
					}
					
				</span>
	}
}


export default Radium(PriceLabel);


// WEBPACK FOOTER //
// ./src/views/product/PriceLabel.js